module.exports = __webpack_public_path__ + "media/club/icookin-serial-6abca0b2.webp";